import React from 'react';
import { Box, Grid, Paper, Typography, Card, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';

const StatCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

const Dashboard = () => {
  const stats = [
    { title: 'Total Services', value: '7', color: '#1976d2' },
    { title: 'Healthy Services', value: '6', color: '#4caf50' },
    { title: 'Active Users', value: '3', color: '#ff9800' },
    { title: 'Data Processed', value: '1,247', color: '#9c27b0' },
  ];

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      
      <Grid container spacing={3}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <StatCard>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  {stat.title}
                </Typography>
                <Typography variant="h4" component="h2" sx={{ color: stat.color }}>
                  {stat.value}
                </Typography>
              </CardContent>
            </StatCard>
          </Grid>
        ))}
        
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              System Overview
            </Typography>
            <Typography variant="body1">
              Welcome to the AOC ETO API Admin Panel. This dashboard provides comprehensive 
              system management capabilities including endpoint configuration, user management, 
              and system monitoring.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
